import { use } from "react";

import { KioskContext } from "./kiosk-context";

export const useKioskContext = () => {
	const context = use(KioskContext);
	if (!context) {
		throw new Error(
			"useKioskContext must be used within a KioskContextProvider",
		);
	}

	return context;
};
